export default class Contrast {
    constructor(key, section, parts, contrastKey) {
        //this.key = key;
        this.section = section;
        this.parts = parts;
        this.contrastKey = contrastKey;
    }
}